import toast from "@components/toast/toast"
import stationHelper from "../../helpers/station_helper"
import store from "../../store/modal_measurements/store"
import DatePicker from "../date_picker/date_picker"
import Card from "./card/card"
import Chart from "./chart/chart"
import Title from "./title/title"

export default function ModalMeasurements(opts={}){
    BaseConstructor.call(this)
    let {container, station} = opts
    let elements = {}
    let context = this
    let current_station
    let chartComponent, titleComponent,cardMax,cardMin,datePickerComponent
    init()

    this.generate = () =>{

    }

    this.update = (station, start_date,end_date) =>{
        $("#modal_measurements").modal('show')
        
        if(!chartComponent){
            chartComponent = new Chart({container: "#modal_measurements #chart-measurements", station: station})
            chartComponent.generate()
        }

        titleComponent.setStation(station)

        let ids = Array.isArray(station) ? station.map(x=>x.id) : [station.id]
        
        //pegando medições
        chartComponent.loading(true)
        stationHelper.getStationsMeasurements(ids, start_date.toISOString(), end_date.toISOString()).then(data=>{
            chartComponent.generateChart(station,start_date ,end_date,data.measurements)
            setCardMaxData(ids, data.measurements,start_date, end_date)
        }).fail(e=>{
            console.log((e));
            toast.warning({text: 'Erro ao consultar medições do posto'})
        }).always(_=>{
            chartComponent.loading(false)
        })


        // cardMax.generate({content: 'teste'})
    }

    function init(){
        $(document.body).append(modalStructure())
        titleComponent = new Title({container: '.modal-measurements-title-container'})
        cardMax = new Card({container: '.modal-measurements-cards', title: 'SUPER Max'})
        datePickerComponent = new DatePicker({container:'.modal-measurements-cards', singleDatePicker:false})
        datePickerComponent.generate()
        
        datePickerComponent.on('date-picker-change', data=>{
            context.update(current_station, data.start, data.end)
        })

        store.subscribe('SET_STATION', station=>{
            current_station = station
            datePickerComponent.setDate(new Date(new Date().getTime() - 24 * 60 * 60  * 1000), new Date())
            
        })
    }

    const setCardMaxData = (station, measurements, start_date, end_date) =>{
        let is_plu = station.length > 1 ? true : false
        let _disp = dispCalc(measurements, start_date, end_date)

        if(!is_plu){
            cardMax.generate({contents: [
                {value:(is_plu ? maxMeasurement(measurements).value : maxMeasurement(measurements).value/100).toFixed(3), title: 'Max', footer:new Date(maxMeasurement(measurements).date).toLocaleString()},
                {value:(is_plu ? minMeasurement(measurements).value : minMeasurement(measurements).value/100).toFixed(3), title: 'Min',footer:new Date(minMeasurement(measurements).date).toLocaleString()},
                {value:`<div style='color:${colorByDisp(_disp.value)}'>${_disp.value.toFixed(1)}%</div>`, title: 'Disponibilidade', tooltip:{text: `${measurements.length}/${_disp.expected}`}}
            ]})
        } else{
            cardMax.generate({contents:[]})
        }
        
    }

    const maxMeasurement = measurements =>{
        return _.maxBy(measurements, m=> m.value)
    }
    const minMeasurement = measurements =>{
        return _.minBy(measurements, m=> m.value)
    }

    const dispCalc = (measurements,start_date ,end_date)=>{
        let diff_in_minutes = diffInminutes(start_date, end_date)
        let station = store.getStation()
        let expected = Math.floor(diff_in_minutes / station.transmission_gap)
        let disp = (measurements.length * 100 / expected)
        return {value: disp > 100 ? 100 : disp, expected: expected}
    }

    const colorByDisp = disp_value =>{
        if(disp_value>=95){
            return 'var(--success)'
        } else if(disp_value >= 85){
            return 'var(--warning)'
        } else {
            return 'var(--danger)'
        }
    }

    const diffInminutes = (start_date, end_date) =>{
        //caso selecionada uma data futura, desconsiderando..
        end_date = end_date.getTime() > new Date().getTime() ? new Date() : end_date
        let diff =(start_date.getTime() -  end_date.getTime())/ 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }

    function modalStructure(){
        return  '<div class="modal fade" tabindex="-1" role="dialog" id="modal_measurements">'+
                    '<div class="modal-dialog modal-dialog-centered modal-xxl" role="document">'+
                        '<div class="modal-content">'+
                            '<div class="modal-body">'+
                                '<div class="modal-measurements-title-container mb-3"></div>'+
                                '<div id="chart-measurements"></div>'+
                                '<div class="modal-measurements-cards flex flex-gap"></div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                '</div>'
    }
}

ModalMeasurements.prototype = Object.create(BaseConstructor.prototype)